<div class="alert-message {{ variant }}">
  <dp-icon-svg *ngIf="icon" name="{{ icon }}" class="alert-icon"></dp-icon-svg>
  <p *ngIf="text">
    {{ text }}
  </p>
</div>
